import { AppContent } from 'content/AppContent';

import { MetaContentValues } from '../metaContentValues';

const mortgageConditions: AppContent['mortgageConditions'] = {
  metaContent: MetaContentValues.mortgageConditions,
  heading: 'Birmingham Midshires mortgage conditions',
  paragraph1: {
    text1: "It's important you read your mortgage conditions and ",
    link: {
      text: 'information about your mortgage',
      url: '/public/properties_to_be_let_mortgage_guide.pdf',
    },
    text2: ' so you understand how your mortgage works.',
  },
  paragraph2: {
    text1: 'The ',
    link: {
      text: 'Birmingham Midshires mortgage conditions booklet',
      url: '/public/bm_mortgage_conditions_2019.pdf',
    },
    text2:
      ' explains everything you need to know about your mortgage, including what makes up the mortgage agreement, how the agreement will work and the mortgage security we take over your property.',
  },
  backButton: 'Back to Knowledge base',
};

export default mortgageConditions;
